import { render, staticRenderFns } from "./ControlCom.vue?vue&type=template&id=6674025c&scoped=true"
import script from "./ControlCom.vue?vue&type=script&lang=js"
export * from "./ControlCom.vue?vue&type=script&lang=js"
import style0 from "./ControlCom.vue?vue&type=style&index=0&id=6674025c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6674025c",
  null
  
)

export default component.exports